export const genders = [
  { label: '男性', value: 'M' },
  { label: '女性', value: 'F' },
]
